import { useEffect, useState } from "react";
import { useDataFetch } from "../useDataFetch";
import { useToast } from "../useToast";

const useBoxSizes = () => {
  const [state] = useDataFetch({ method: "GET", url: "/box-sizes" });
  const [boxSizes, setBoxSizes] = useState([]);
  const [selectItemBoxSizes, setSelectItemBoxSizes] = useState([]);
  const [boxSizesPure, setBoxSizesPure] = useState([]);
  const { addToast } = useToast();

  useEffect(() => {
    if (!state?.isLoading && !state?.isError && state?.data) {
      let values = state?.data?.payload;
      const list = [];
      const selectItemList = [];
      setBoxSizesPure(values);
      values?.forEach((item) => {
        list.push({
          _id: item.id,
          name: `${item.name} (${item.width} * ${item.height} * ${item.depth})`,
          title: `${item.name} (${item.width} * ${item.height} * ${item.depth})`,
          default: false,
        });
        selectItemList?.push({
          id: item?.id,
          name: item?.name,
          width: "عرض (cm): " + item?.width?.toLocaleString()?.toPersianDigits(),
          height: "طول (cm): " + item?.height?.toLocaleString()?.toPersianDigits(),
          depth: "ارتفاع (cm): " + item?.depth?.toLocaleString()?.toPersianDigits(),
          default: false,
        });
      });
      setBoxSizes(list);
      setSelectItemBoxSizes(selectItemList);
    }

    if (!state?.isLoading && state?.isError) {
      addToast("error", "خطا در دریافت اطلاعات بسته");
    }
  }, [state]); // eslint-disable-line

  return [boxSizes, boxSizesPure, selectItemBoxSizes, state?.isLoading];
};

export default useBoxSizes;
